import { EntityLinks, GoalType } from '@griply/types';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { IconFormIcons, Target } from 'shared/assets/icons';
import { ListSectionGoalHeader } from 'shared/components/ui/list-section-goal-header';
import { Goal } from 'shared/types/goal';
import { ID } from 'shared/types/id';
import { LifeArea } from 'shared/types/life-area';
import { goalInboxID } from 'shared/types/orderable-section';
import { getLinkedItemColor } from 'shared/utils/get-linked-item-color';

export type GoalHeaderProps = {
  goalId?: ID;
  goals: Goal[];
  lifeAreas: LifeArea[];
  links: EntityLinks;
  isLink?: boolean;
  onPremium: () => void;
};

export const GoalHeader: React.FC<GoalHeaderProps> = React.memo(
  ({ goalId, goals, lifeAreas, links, isLink, onPremium }) => {
    const { t } = useTranslation();
    const goal = useMemo(
      () => goals.find(({ id }) => id === goalId),
      [goals, goalId],
    );

    const goalColor = useMemo(
      () =>
        goal?.id
          ? getLinkedItemColor(goal.id, { lifeAreas, goals, links }) ??
            undefined
          : undefined,
      [goal?.id, goals, lifeAreas, links],
    );

    const goalName = !goalId
      ? t('general.sections.goals.other.title')
      : goal?.name ?? '';

    return (
      <ListSectionGoalHeader
        id={goalId}
        name={goalName}
        image={goal?.image}
        imagePlaceholderIcon={
          !goalId || goalId === goalInboxID
            ? Target
            : goal?.iconName
              ? IconFormIcons[goal.iconName]
              : undefined
        }
        color={goalColor}
        onPremium={onPremium}
        isLink={!!goalId && goalId !== goalInboxID && isLink}
        isFrozen={!!goal?.frozenAt}
        isCompleted={!!goal?.completedAt}
        isProject={goal?.type === GoalType.Project}
      />
    );
  },
);
